import pino, { type LevelOrString, type Logger } from "pino";

import { createWrite } from "./utils/pretty";
import { send } from "./utils/sendToBackend";

let rootLogger: Logger | undefined;

interface LoggerContextBase {
    module?: string;
}

const rootBindings: Record<string, unknown> = {};

interface InitLoggingProps {
    commitHash: string;
    appName: string;
    channel?: string;
    logLevel: {
        api: LevelOrString;
        console: LevelOrString;
    };
    isConsoleLogEnabled?: boolean;
    mixin?: () => Record<string, unknown>;
}

export function initLogging({
    appName,
    logLevel,
    commitHash,
    channel,
    isConsoleLogEnabled = true,
    mixin,
}: InitLoggingProps) {
    rootLogger = pino({
        browser: {
            write: isConsoleLogEnabled ? createWrite(logLevel.console.toLowerCase(), { mixin }) : () => {},
            transmit: {
                level: logLevel.api.toLowerCase(),
                send: (level, logEvent) => send(level, logEvent, { mixin }),
            },
        },
    });
    rootBindings.appName = appName;
    rootBindings.commitHash = commitHash;
    rootBindings.channel = channel;
    rootBindings.surface = "frontend";
}

export function getLogger<TContext extends LoggerContextBase = LoggerContextBase>(
    context: TContext & Record<string, string>,
) {
    if (!rootLogger) throw new Error("initLogging() not yet called");
    const loggerContext = {
        ...context,
        ...rootBindings,
    };
    return rootLogger.child(loggerContext);
}
